import { Container, Row, Col, Form, Button } from "react-bootstrap";

export default function IntegrationsBranch(props) {

	return (
		<Container className="pt-4 pb-5 px-3 px-lg-5">

			<Row className="d-flex align-items-center m-0">
				<Col className="px-0">
					<h2 className="SFProDisplay-Bold m-0">
						<span className="text-capitalize">{props.config.wording.text_9}</span> {props.config.wording.text_10}
					</h2>
				</Col>
			</Row>

			<Row className="d-flex align-items-center pt-4 m-0">
				<Col className="px-0">
					<h5 className="SFProDisplay-Bold m-0">
						{props.config.wording.text_1}
					</h5>
				</Col>
			</Row>

			<Row className="pt-4 m-0">
				<Col lg={4} className="px-0">
					<Form.Group>
						<Form.Label className="SFProDisplay-Semibold">
							{props.config.wording.text_2}
						</Form.Label>
						<Form.Control
							type="text"
							placeholder={props.config.wording.text_3}
							defaultValue={props.integtationData.live_key}
							key={props.integtationData.live_key}
							className="mb-2"
							onChange={(e) => props.handleIntegrationsSettings("live_key", e.target.value)}
						/>
						<Form.Text>
							{props.config.wording.text_4}
						</Form.Text>
					</Form.Group>
					<Form.Group className="pt-3">
						<Form.Label className="SFProDisplay-Semibold">
							{props.config.wording.text_5}
						</Form.Label>
						<Form.Control
							type="text"
							placeholder={props.config.wording.text_6}
							defaultValue={props.integtationData.test_key}
							key={props.integtationData.test_key}
							className="mb-2"
							onChange={(e) => props.handleIntegrationsSettings("test_key", e.target.value)}
						/>
						<Form.Text>
							{props.config.wording.text_7}
						</Form.Text>
					</Form.Group>
				</Col>
			</Row>

			<Row className="pt-4 m-0">
				<Col xs="auto" className="px-0">
					<Button className="px-4 rounded-5" onClick={props.handleSubmitIntegrationSettings}>
						{props.config.wording.text_8}
					</Button>
				</Col>
			</Row>

		</Container>
	)
}